const NETWORK_ERROR_MESSAGE = "اتصال اینترنت را بررسی کنید.";

const fieldLabels = {
  mobile: "شماره موبایل",
  customer_mobile: "شماره موبایل",
  phone: "شماره تماس",
  password: "رمز عبور",
  current_password: "رمز عبور فعلی",
  otp: "کد تایید",
  name: "نام",
  customer_name: "نام گیرنده",
  receiver_name: "نام گیرنده",
  province: "استان",
  city: "شهر",
  address: "آدرس",
  postal_code: "کد پستی",
  plaque: "پلاک",
  unit: "واحد",
  shipping_method_id: "روش ارسال",
  cart: "سبد خرید",
  code: "کد تخفیف",
  discount_code: "کد تخفیف"
};

const cleanMessage = (message, fallback = "اطلاعات را بررسی کنید.") => {
  if (!message) return fallback;

  const text = String(message).trim();

  const common = {
    "The given data was invalid.": "اطلاعات را بررسی کنید.",
    "Unauthenticated.": "برای ادامه وارد شوید.",
    "Too Many Attempts.": "کمی بعد دوباره تلاش کنید.",
    "Server Error": "مشکل موقت سرور.",
    "Network Error": "اتصال را بررسی کنید."
  };

  if (common[text]) return common[text];

  return text;
};

export const getApiErrors = (err) => {
  const errors = err?.data?.errors;

  if (!errors || typeof errors !== "object") {
    return {};
  }

  return errors;
};

export const getFieldError = (errors, field) => {
  const value = errors?.[field];

  if (Array.isArray(value)) {
    return cleanMessage(value[0]);
  }

  if (typeof value === "string") {
    return cleanMessage(value);
  }

  return "";
};

export const getFirstError = (errors, fallback = "اطلاعات را بررسی کنید.") => {
  const keys = Object.keys(errors || {});

  if (!keys.length) return fallback;

  return getFieldError(errors, keys[0]) || fallback;
};

export const getFriendlyApiError = (err, fallback = "اطلاعات را بررسی کنید.") => {
  if (
    !navigator.onLine ||
    err?.status === "FETCH_ERROR" ||
    err?.error === "TypeError: Failed to fetch" ||
    String(err?.error || err?.message || "").toLowerCase().includes("failed to fetch") ||
    String(err?.error || err?.message || "").toLowerCase().includes("networkerror")
  ) {
    return NETWORK_ERROR_MESSAGE;
  }

  const errors = getApiErrors(err);

  if (Object.keys(errors).length) {
    return getFirstError(errors, fallback);
  }

  return cleanMessage(err?.data?.message || err?.error || err?.message, fallback);
};

export const getSimpleFieldLabel = (field) => fieldLabels[field] || field;


export const isNetworkError = (err) =>
  !navigator.onLine ||
  err?.status === "FETCH_ERROR" ||
  err?.error === "TypeError: Failed to fetch" ||
  String(err?.error || err?.message || "").toLowerCase().includes("failed to fetch") ||
  String(err?.error || err?.message || "").toLowerCase().includes("networkerror");
